import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { Button, Select, TextInput } from '@coursera/coursera-ui';

import { resetApp, setProtocol, setUrl } from 'bundles/widget-simulator/actions/WidgetSimulatorActions';
import { PROTOCOL_OPTIONS } from 'bundles/widget-simulator/constants';
import type WidgetSimulatorStoreClass from 'bundles/widget-simulator/stores/WidgetSimulatorStore';
import type { ProtocolOption } from 'bundles/widget-simulator/types';

import _t from 'i18n!nls/widget-simulator';

import 'css!./__styles__/Toolbar';

type PropsFromCaller = {};

type PropsFromStores = {
  protocol: string;
  urlPrefix: string;
  url: string;
};

export type PropsToComponent = PropsFromCaller & PropsFromStores;

type State = {
  url?: string;
  hasInputUrl: boolean;
};

export class Toolbar extends React.Component<PropsToComponent, State> {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof Toolbar.contextTypes>;

  state = {
    url: '',
    hasInputUrl: false,
  };

  handleProtocolChange = (newOption: ProtocolOption) => {
    const { executeAction } = this.context;
    const newProtocol = newOption.value;
    executeAction(setProtocol, { protocol: newProtocol });
  };

  onUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      url: event.target.value,
      hasInputUrl: true,
    });
  };

  onUrlKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      this.sendUrlChange();
    }
  };

  sendUrlChange = () => {
    const { executeAction } = this.context;
    const { urlPrefix, url: storedUrl } = this.props;
    const { url, hasInputUrl } = this.state;
    let newUrl = ((hasInputUrl ? url : storedUrl) || '').trim();

    if (newUrl.startsWith(urlPrefix)) {
      newUrl = newUrl.replace(new RegExp(`^${urlPrefix}`), '');
    }

    executeAction(setUrl, { url: newUrl });
    executeAction(resetApp);
    this.setState({ url: undefined, hasInputUrl: false });
  };

  render() {
    const { protocol, url: storedUrl } = this.props;
    const { url, hasInputUrl } = this.state;
    const urlToDisplay = hasInputUrl ? url : storedUrl;

    return (
      <div className="rc-Toolbar horizontal-box">
        <Select value={protocol} options={PROTOCOL_OPTIONS} onChange={this.handleProtocolChange} />

        <TextInput
          componentId="toolbar-url-input"
          value={urlToDisplay}
          placeholder="Enter the URL of your plugin"
          onChange={this.onUrlChange}
          nativeHtmlAttributes={{
            onKeyDown: this.onUrlKeyDown,
          }}
        />

        <div className="go-button-container">
          <Button size="zero" rootClassName="p-l-1 p-r-1" label={_t('Go')} onClick={this.sendUrlChange} />
        </div>
      </div>
    );
  }
}

type Stores = {
  WidgetSimulatorStore: typeof WidgetSimulatorStoreClass;
};

export default compose<PropsToComponent, PropsFromCaller>(
  connectToStores<PropsToComponent, {}, Stores>(['WidgetSimulatorStore'], ({ WidgetSimulatorStore }) => ({
    protocol: WidgetSimulatorStore.getProtocol(),
    urlPrefix: WidgetSimulatorStore.getUrlPrefix(),
    url: WidgetSimulatorStore.getUrl(),
  }))
)(Toolbar);
